import axios from "axios";
import { config } from "@/constants";
import router from "@/router";
import store from "@/store";
import auth from "@/services/auth";
import { SET_LOCALE } from "@/store/mutation-types";
import cookies from "@/storage/cookies";
import qs from "qs";

export const ACCESS_TOKEN_COOKIE_NAME = "access_token";

const headers = {
  "X-Requested-With": "XMLHttpRequest",
  "Cache-Control": "no-cache",
  Accept: "application/ld+json, application/json, text/plain, */*",
  "Content-Type": "application/ld+json",
};

let accessToken = cookies.get(ACCESS_TOKEN_COOKIE_NAME);

if (accessToken) {
  headers["Authorization"] = `Bearer ${accessToken}`;
}

export const patchAxiosConfig = {
  headers: {
    "Content-Type": "application/merge-patch+json",
  },
};

const instance = axios.create({
  baseURL: config.apiBaseURL,
  timeout: config.apiTimeout,
  withCredentials: true,
  headers,
  paramsSerializer: params => qs.stringify(params),
  transformRequest: [
    function(data) {
      if (data && typeof data === "object") {
        Object.keys(data).forEach(
          key => (data[key] = data[key] === undefined ? null : data[key])
        );
        data = JSON.stringify(data);
      }

      return data;
    },
  ],
});

instance.interceptors.response.use(
  response => {
    const locale = response.headers["x-locale"];
    if (locale && store.getters.locale !== locale) {
      store.commit(SET_LOCALE, locale);
    }

    return response;
  },
  async error => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) {
        if (error.response.config.url.indexOf("/authentication-token") < 0) {
          await auth.clear();

          if (window.location.pathname.indexOf("/invite") === -1) {
            router.push({ name: "login" });
          }
        }

        return Promise.reject(error);
      }

      if (error.response.data && error.response.data.code) {
        error.code = error.response.data.code;
      }

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

instance.setAccessToken = function(accessToken) {
  instance.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
};

instance.removeAccessToken = function() {
  delete instance.defaults.headers["Authorization"];
};

export default instance;
